import React from 'react';
import { calc, subscribe } from '@ok/blade';

import { toLocale } from '@common/i18n';
import utils from '@common/utils';
import {
  EVENT_EMITTER_KEYS,
  PLACEHOLDER,
} from '@pages/currencyInfo/common/context';

import URL from '../../common/URL';

import './index.less';

const { utils: { ont } = {} } = window;

const dateChangeKeys = [
  'todayChange',
  'sevenDayChange',
  'thirtyDayChange',
  'thisYearChange',
];

const dateChangeMap = {
  todayChange: toLocale('today_change_date'),
  sevenDayChange: toLocale('seven_days_date'),
  thirtyDayChange: toLocale('thirty_days_date'),
  thisYearChange: toLocale('this_year_date'),
};

class PriceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  getPriceColor(value) {
    if (Number(value) < 0) {
      return 'price-red-color';
    }
    return 'price-green-color';
  }

  getPricePreFix(value) {
    if (Number(value) < 0) {
      return '-';
    }
    return '+';
  }

  async fetchPriceList() {
    const { currency } = this.props;
    const currencyId = currency.id;
    const { data: res } = await ont.get(
      `${URL.GET_CURRENCY_PERFORMANCE_INFO}?currencyId=${currencyId}`
    );
    this.setState({ data: res.data });
    subscribe.trigger(EVENT_EMITTER_KEYS.currencyExchangePrice, res.data);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.currency.symbol &&
      prevProps.currency.id !== this.props.currency.id
    ) {
      this.fetchPriceList();
    }
  }

  componentDidMount() {
    const { currency } = this.props;
    const currencyId = currency.id;
    if (utils.isNotEmpty(currencyId)) {
      this.fetchPriceList();
    }
  }

  controlDisplay = () => {
    const { display } = this.state;
    this.setState({ display: !display });
  };

  handleNumberShow = (checkValue, actualValue) => {
    // The backend returns an empty string
    if (checkValue === '') {
      return actualValue;
    }
    if (Number(checkValue) < 0) {
      return Number(String(actualValue).slice(1));
    }
    return Number(actualValue);
  };

  displayPrice = (dataKey, quotePrecision) => {
    if (/^[\d\\.]+$/.test(dataKey)) {
      return (
        <>
          <span className="currency-symbol">¥</span>
          {calc.showFloorTruncation(dataKey, quotePrecision)}
        </>
      );
    }
    return PLACEHOLDER;
  };

  percentShow = (preFix, dataChanger) => {
    if (/^[\d\\.]+$/.test(dataChanger)) {
      return (
        <>
          <span className="prefix-percentage-symbol">{preFix}</span>
          {calc.floorTruncate(dataChanger, 2)}%
        </>
      );
    }
    return PLACEHOLDER;
  };

  render() {
    const { data } = this.state;
    const { quotePrecision } = data;
    const {
      currency: { fullName = PLACEHOLDER, symbol = PLACEHOLDER },
    } = this.props;
    return (
      <div className="price-list-wrapper">
        <div className="list-title">
          <div className="date-range">
            {fullName}（{symbol}）{toLocale('currency_price_performance')}
          </div>
        </div>
        <div className="list-content">
          <div className="list-content-title">
            <div>{toLocale('currency_time_range')}</div>
            <div>{toLocale('currency_price_amount')}</div>
            <div>{toLocale('currency_price_rate')}</div>
          </div>
          {dateChangeKeys.map((key, index) => {
            const itemClassName = this.getPriceColor(data[key]);
            const preFix = this.getPricePreFix(data[key]);
            const dataKey = this.handleNumberShow(data[key], data[key]);
            const dataChanger = this.handleNumberShow(
              data[key],
              data[`${key}Per`]
            );
            return (
              <div key={index}>
                <div>{dateChangeMap[key]}</div>
                <div className={itemClassName}>
                  {this.displayPrice(dataKey, quotePrecision)}
                </div>
                <div className={itemClassName}>
                  {this.percentShow(preFix, dataChanger)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default PriceList;
